import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';
@Component({
  selector: 'app-top-selling-products',
  templateUrl: './top-selling-products.component.html',
  styleUrls: ['./top-selling-products.component.scss'],
  standalone: false
})
export class TopSellingProductsComponent {
  @Input() products: Product[] = [];
  @Input() eventId!: string;
  @Output() seeAllClicked = new EventEmitter<void>();
  @Output() seeTicketSoldInfo = new EventEmitter<number>();
  @Output() productDetailsRequested = new EventEmitter<Product>();

  dropdownOpenId: number | null = null;

  onSeeAllClick() {
    this.seeAllClicked.emit();
  }

  onSeeTicketSoldInfo(productId: number) {
    this.seeTicketSoldInfo.emit(productId);
  }

  openDropdown(productId: number | null) {
    this.dropdownOpenId = productId;
  }
}
